import { ExternalLink, ShieldCheck, UserRound, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";

export function AuthModal() {
  const { modal, closeLogin } = useAuth();
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!modal) return;
    closeRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") closeLogin();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [modal, closeLogin]);

  if (!modal) return null;

  const continueWithKook = () => {
    modal.onBeforeRedirect?.();
    window.location.assign("/api/auth/kook?returnTo=" + encodeURIComponent(modal.returnTo));
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && closeLogin()}>
      <section className="modal auth-modal" role="dialog" aria-modal="true" aria-labelledby="auth-title">
        <header className="modal-header">
          <div><p className="eyebrow">Secure OAuth</p><h2 id="auth-title">使用 KOOK 账号登录</h2></div>
          <button ref={closeRef} className="icon-button" onClick={closeLogin} aria-label="关闭登录弹窗"><X size={19} /></button>
        </header>
        <p className="modal-copy">将跳转到 KOOK 官方授权页面。完成授权后回到 GAMEFRAME，当前提示词与生成参数会被保留。</p>
        <div className="oauth-scope-card">
          <span className="kook-mark" aria-hidden="true">K</span>
          <div><strong>KOOK 基础用户信息</strong><small>仅读取用户 ID、昵称与头像</small></div>
          <ShieldCheck size={20} aria-label="安全授权" />
        </div>
        <ul className="oauth-points">
          <li><UserRound size={15} />仅申请 <code>get_user_info</code> 权限</li>
          <li><ShieldCheck size={15} />不会获取或保存你的 KOOK 密码</li>
          <li><ExternalLink size={15} />授权页面由 KOOK 官方提供</li>
        </ul>
        <button className="button button-primary button-full" onClick={continueWithKook}>前往 KOOK 安全授权</button>
        <p className="legal-note">继续即表示你同意 <Link to="/terms" onClick={closeLogin}>用户协议</Link> 与 <Link to="/privacy" onClick={closeLogin}>隐私政策</Link>。</p>
      </section>
    </div>
  );
}
